
export class TableColumn {
defaultValue: string;
length: string;
name: string;
notNull: boolean | null;
order: number | null;
type: string;
uniqueKey: boolean | null;
}

